module.exports = __webpack_public_path__ + "img/banner_ios_s.8578641.png";